const ventures = [
  {
    id: "santa-cruz-tutors",
    name: "Santa Cruz Tutors",
    role: "Co-Founder",
    copy: "Built and operated an education business, developed the customer-facing platform, hired and managed talent, and grew a network of 20+ tutors and music instructors."
  },
  {
    id: "blink-records",
    name: "Blink Records",
    role: "Co-Founder",
    copy: "Built an independent music company spanning original releases, distribution, audience development, digital marketing, and grassroots business development."
  }
];

export const BuilderSection = () => (
  <section id="builder" className="py-12 sm:py-16 bg-[#0A0A0A]" data-testid="builder-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="text-xs sm:text-sm font-mono text-[#D4AF37] tracking-widest uppercase mb-3">Builder Beyond the Org Chart</div>
      <p className="text-sm sm:text-base text-zinc-300 leading-relaxed mb-8 max-w-3xl">
        Building has been a theme throughout my career, inside and outside SaaS. Before leading Sales Development organizations, I co-founded an education business, and I continue to build entrepreneurial and creative projects today.
      </p>
      <div className="grid sm:grid-cols-2 gap-4">
        {ventures.map((v) => (
          <div key={v.id} className="p-5 bg-[#1C1C1C]/60 rounded-xl border border-white/5" data-testid={`venture-${v.id}`}>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wide">{v.name}</h3>
            <p className="text-xs text-[#D4AF37] mb-2">{v.role}</p>
            <p className="text-sm text-zinc-400 leading-relaxed">{v.copy}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BuilderSection;
